export default {
  bodyBg: '#0A0317',
  primary: '#e5007d',
};
